var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTippy
    ? _c(
        "emd-tippy",
        {
          attrs: {
            position: "top",
            type: "html",
            "aria-expanded": "true",
            "data-testid": "emd-tippy-dash-info-icon",
            id: _vm.tooltipId,
            "data-template": _vm.tooltipId,
          },
        },
        [
          _c("em", {
            staticClass: "emd-text eu-ml_1 _color_success uil uil-info-circle",
          }),
          _c(
            "emd-tippy-template-HTML",
            { attrs: { id: _vm.tooltipId } },
            _vm._l(_vm.tooltipList, function (item) {
              return _c(
                "emd-text",
                {
                  key: item.name,
                  attrs: {
                    size: "tiny",
                    "data-testid": "emd-text-dash-info-icon",
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t(item.name)) + " "),
                  item.percentage
                    ? [_vm._v(": " + _vm._s(item.percentage) + "%")]
                    : _vm._e(),
                  _c("br"),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }